export const popupVideo = () => {
    if (document.querySelector('.open-popup-video-js')) {
        document.querySelectorAll('.open-popup-video-js').forEach(function (item, index) {
            item.addEventListener('click', () => {
                document.querySelector('.popup-video video').setAttribute('src', `${item.getAttribute('data-video-src')}`)
                document.querySelector('.popup-video__youtube').classList.remove('active')
                document.querySelector('.popup-video').classList.add('active')
                document.querySelector('.popup-video video').classList.add('active')
            })
        })

        document.querySelector('.popup-video__play').addEventListener('click', () => {
            document.querySelector('.popup-video video').play();
            document.querySelector('.popup-video__play').classList.add('hidden')
            document.querySelector('.popup-video video').setAttribute('controls', `true`)
        })

        document.querySelectorAll('.popup-video__close, .popup-video__bg').forEach(function (item, index) {
            item.addEventListener('click', () => {
                document.querySelector('.popup-video__play').classList.remove('hidden')
                document.querySelector('.popup-video video').pause();
                document.querySelector('.popup-video__youtube').innerHTML = ``
                document.querySelector('.popup-video video').removeAttribute('controls')
                document.querySelector('.popup-video').classList.remove('active')
            })
        })
    }
    if (document.querySelector('.open-popup-youtube-js')) {
        document.querySelectorAll('.open-popup-youtube-js').forEach(function (item, index) {
            item.addEventListener('click', () => {
                document.querySelector('.popup-video__youtube').innerHTML = `${item.getAttribute('data-youtube-src')}`
                document.querySelector('.popup-video__youtube').classList.add('active')
                document.querySelector('.popup-video video').classList.remove('active')
                document.querySelector('.popup-video').classList.add('active')
                document.querySelector('.popup-video__play').classList.add('hidden')
            })
        })
    }
}
